var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import styles from './ExternalApprovals.module.scss';
import { Api } from '@app/Api';
import { Grid } from '@app/Components/Grid/Grid';
import { Column, Sorting, FilterRow } from 'devextreme-react/data-grid';
import { withRouter, Switch, Route } from 'react-router-dom';
import { AddApprovalModal } from '../Gates/GateView/AddApprovalModal';
import { ApprovalApplicationCell } from './ApprovalApplicationCell';
import { ApprovalApplicationEnum, SeparatedStrings } from '@app/AppConstants';
export function renderApprovalApplication(approvalApplication) {
    if (approvalApplication === ApprovalApplicationEnum.TeamGate) {
        return SeparatedStrings.ApprovalApplicationTeamGate;
    }
    else if (approvalApplication === ApprovalApplicationEnum.MFiles) {
        return SeparatedStrings.ApprovalApplicationMFiles;
    }
    return approvalApplication;
}
var ExternalApprovalsC = /** @class */ (function (_super) {
    __extends(ExternalApprovalsC, _super);
    function ExternalApprovalsC() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadingDeliverables = false;
        _this._deliverables = [];
        return _this;
    }
    ExternalApprovalsC.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._loadDeliverables()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ExternalApprovalsC.prototype._loadDeliverables = function () {
        return __awaiter(this, void 0, void 0, function () {
            var gateId, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        gateId = this.props.gateId;
                        this.loadingDeliverables = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 3, 4]);
                        _a = this;
                        return [4 /*yield*/, Api.secured.getGateDeliverableShortModels({ gateId: gateId })];
                    case 2:
                        _a._deliverables = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.loadingDeliverables = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ExternalApprovalsC.prototype._approvalApplicationSaveHandler = function (id, value) {
        return __awaiter(this, void 0, void 0, function () {
            var deliverable;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Api.secured.setApprovalApplicationForDeliverable(id, { approvalApplication: value })];
                    case 1:
                        _a.sent();
                        deliverable = this._deliverables.find(function (x) { return x.id == id; });
                        if (deliverable) {
                            deliverable.approvalApplication = value;
                            this._deliverables = __spreadArray([], this._deliverables, true);
                        }
                        return [4 /*yield*/, this._loadDeliverables()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ExternalApprovalsC.prototype.render = function () {
        var _this = this;
        var _a = this.props, match = _a.match, projectId = _a.projectId, gateId = _a.gateId, editable = _a.editable;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.wrapper },
                React.createElement("div", { className: styles.table },
                    React.createElement(Grid, { dataSource: this._deliverables, loading: this.loadingDeliverables },
                        React.createElement(Sorting, { mode: "multiple" }),
                        React.createElement(FilterRow, { visible: true }),
                        React.createElement(Column, { caption: "Id", dataField: "checkListItemCode", width: 120, defaultSortOrder: "asc" }),
                        React.createElement(Column, { caption: "Deliverable Name", dataField: "deliverableName", width: 250 }),
                        React.createElement(Column, { dataField: "isExternalManagement", visible: false, calculateCellValue: function (data) {
                                return renderApprovalApplication(data.approvalApplication);
                            } }),
                        React.createElement(Column, { caption: "Approval Application", dataField: "approvalType", minWidth: 200, allowEditing: false, cssClass: styles.editColumn, calculateFilterExpression: function (value) {
                                return [['isExternalManagement', 'contains', value]];
                            }, cellRender: function (_a) {
                                var data = _a.data;
                                return (React.createElement(ApprovalApplicationCell, { disabled: !editable || data.approvalApplication === ApprovalApplicationEnum.MFiles, value: data.approvalApplication, deliverable: data, onSave: _this._approvalApplicationSaveHandler }));
                            } }),
                        React.createElement(Column, { caption: "Is Externally Configured", dataField: "isExternallyConfigured", width: 200, allowFiltering: true, calculateCellValue: function (m) {
                                return m.isExternallyConfigured ? 'Yes' : 'No';
                            } })))),
            React.createElement(Switch, null,
                React.createElement(Route, { path: "".concat(match.url, "/add") },
                    React.createElement(AddApprovalModal, { backUrl: "".concat(match.url), projectId: projectId, gateId: gateId || 0, approvalTimeUnit: this.props.approvalTimeUnit, onClose: this._loadDeliverables })))));
    };
    __decorate([
        observable
    ], ExternalApprovalsC.prototype, "loadingDeliverables", void 0);
    __decorate([
        observable.deep
    ], ExternalApprovalsC.prototype, "_deliverables", void 0);
    __decorate([
        action.bound
    ], ExternalApprovalsC.prototype, "_loadDeliverables", null);
    __decorate([
        action.bound
    ], ExternalApprovalsC.prototype, "_approvalApplicationSaveHandler", null);
    ExternalApprovalsC = __decorate([
        observer
    ], ExternalApprovalsC);
    return ExternalApprovalsC;
}(React.PureComponent));
export var ExternalApprovals = withRouter(ExternalApprovalsC);
